exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mode-box[data-v-7ad25c9e]{display:flex;align-items:center;cursor:default;user-select:none}.mode-box[data-v-7ad25c9e]:not(.active){opacity:.5}.mode-box .mode-display[data-v-7ad25c9e]{margin-left:10px;margin-right:10px}.mode-box .mode-display .mode-count[data-v-7ad25c9e],.mode-box .mode-display .mode-name[data-v-7ad25c9e]{font-weight:600;text-align:center}.mode-box .mode-display .mode-name[data-v-7ad25c9e]{font-size:12px;margin-bottom:2px}.mode-box .mode-display .mode-count[data-v-7ad25c9e]{font-size:18px}", ""]);

// exports
